import axios from 'axios';
import { GroupedSection, groupSections } from '../util/privacy-policies';
const apiUrl = process.env.PORTAL_URL || '';

export type SectionItem = {
  id: number;
  status: 'published' | 'draft' | 'archived';
  sort: number;
  user_created: string;
  date_created: string;
  user_updated?: string;
  date_updated?: string;
  sectionTitle: string;
  sectionContent: string;
  sectionSubTitle?: string;
};

export type RequestPrivacyPoliciesProps = {
  data: SectionItem[];
};

const URL = `${apiUrl}/api/dashboard-api/v1/cms/items/privacy_policies`;

const axiosInstance = axios.create({
  baseURL: URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function getPrivacyPolicies(): Promise<GroupedSection[]> {
  const response = await axiosInstance.get<RequestPrivacyPoliciesProps>(URL);

  const { data } = response.data;

  const transformedData = groupSections(data);


  return transformedData;
}
